<template>
  <div class="discover-packs">
    <template v-if="isFetching">
      <div class="p-5 d-flex justify-content-center align-items-center">
        <v-loader />
      </div>
    </template>
    <template v-else>
      <template v-if="isAuthenticated && userHasPackSubscriptions">
        <list boxed class="mt-3">
          <list-item chevron @click="() => $router.push('/me/my-content')">
            <template slot="left">
              <v-icon icon="favorite" class="color-brand" />
            </template>
            <div class="v-list-item__title --centered ml-2">
              {{ $t("components..discover.packs.viewPack") }}
            </div>
          </list-item>
        </list>
      </template>
      <template v-if="packs.length > 0">
        <collection direction="vertical" :items="packs" unlock />
      </template>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

import Collection from "@/components/Collection"
import List from "@/components/List"
import ListItem from "@/components/ListItem"

export default {
  props: {
    active: { type: Boolean, default: false }
  },

  components: {
    Collection,
    List,
    ListItem
  },

  data() {
    return {
      isFetching: false,
      packs: []
    }
  },

  computed: {
    ...mapGetters("packs", ["userHasPackSubscriptions"]),
    ...mapGetters("auth", ["isAuthenticated"])
  },

  methods: {
    ...mapActions("packs", ["fetchPacks"])
  },

  mounted() {
    this.isFetching = true

    this.fetchPacks()
      .then(packs => {
        this.packs = packs
      })
      .finally(() => (this.isFetching = false))
  }
}
</script>
